export const bytesToBase64 = (bytes: Uint8Array) => {
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary);
};

export const svgToDataUrl = (svg: string) =>
  `data:image/svg+xml;base64,${bytesToBase64(new TextEncoder().encode(svg))}`;
